import { ApiMethods } from "../utils/constants"
import { ApiRequest } from "./api-request"

export async function savePatientData(data) {
  try {
    const response = await ApiRequest({
      // url: "/save-user-data",
      url: "/patient/save",
      method: ApiMethods.POST,
      data,
    })
    console.log("savePatientData response 123", response)
    // await Promise((res) => setTimeout(() => res(), 1000))
    const responseData = response.data
    return responseData
  } catch (error) {
    console.log("err", error)
    return { error }
  }
}

export async function updatePatientData(data) {
  try {
    const response = await ApiRequest({
      // url: "/save-user-data",
      url: "/patient/update",
      method: ApiMethods.PUT,
      data,
    })
    console.log("savePatientData response 123", response)
    // await Promise((res) => setTimeout(() => res(), 1000))
    const responseData = response.data
    return responseData
  } catch (error) {
    console.log("err", error)
    return { error }
  }
}
